import React, { useState, useEffect } from "react"
import * as Validator from "../../utils/validator"
import { formatScadenza } from "../../utils/format"
import { postRichiestaRimborso, getTipiVeicoli } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";
import { getTipoProprietario, isRichiedenteDelegato } from "../../utils/utilities";
import {
  Container,
  FormGroup,
  Input,
  Row,
  Col,
  Button,
  Alert,
  Icon,
  Toolbar,
  ToolbarItem,
  Select
} from 'design-react-kit';
import * as Constants from '../../utils/constants'

export const SibaInputFormRichiestaRimborso = (props) => {

  const [isLoading, setLoading] = useState(false);
  const [esito, setEsito] = useState({});
  const [codiceFiscale, setCodiceFiscale] = useState(props.cf);
  const [partitaIva, setPartitaIva] = useState('');
  const [targa, setTarga] = useState(props.datiVeicoloForzati ? props.datiVeicoloForzati.targa : props.targa);
  const [nome, setNome] = useState('');
  const [cognome, setCognome] = useState('');
  const [dataPagamento, setDataPagamento] = useState(props.datiVeicoloForzati ? props.datiVeicoloForzati.dataPagamento : '');
  const [scadenza, setScadenza] = useState(props.datiVeicoloForzati ? props.datiVeicoloForzati.scadenza : '');
  const [validita, setValidita] = useState(props.datiVeicoloForzati ? props.datiVeicoloForzati.validita : 12);
  const [dataNascita, setDataNascita] = useState('');
  const [tipoVeicolo, setTipoVeicolo] = useState(props.datiVeicoloForzati ? props.datiVeicoloForzati.tipoVeicolo : {});
  const [tipiVeicoli, setTipiVeicoli] = useState([]);
  const [comuneNascita, setComuneNascita] = useState('');
  const [provinciaNascita, setProvinciaNascita] = useState('');
  const [descComuneRes, setDescComuneRes] = useState('');
  const [provinciaRes, setProvinciaRes] = useState('');
  const [indirizzoRes, setIndirizzoRes] = useState('');
  const [civicoRes, setCivicoRes] = useState('');
  const [capRes, setCapRes] = useState('');
  const [telefono, setTelefono] = useState('');
  const [email, setEmail] = useState('');
  const [iban, setIban] = useState('');
  const [tabValue, setTabValue] = useState(Constants.STEP_1);
  const [fileUploads, setFileUploads] = useState(new Map());

  useEffect(() => {
    async function fetchData() {
      const listaTipiVeicoli = await getTipiVeicoli();
      console.log("listaTipiVeicoli", listaTipiVeicoli)
      if (listaTipiVeicoli === undefined) {
        console.log('Caricamento tipi veicolo fallito')
        setLoading(false)
        return
      }

      if (props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI) {
        setTipiVeicoli(listaTipiVeicoli.filter(tipo => tipo.value === 4 || tipo.value === 5));
      } else {
        setTipiVeicoli(listaTipiVeicoli)
      }
    }

    if (tipoVeicolo && tipoVeicolo.value) {
      console.log("Non serve fetchData. TipoVeicolo=", tipoVeicolo)
    } else {
      fetchData();
    }
  }, []);

  const isInputDatiVeicoloDisabled = () => {
    return props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI;
  }
  //STALIGK-793: aggiunto veicoli aziendali fuori regione 
  const isDitta = () => {
    return props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI 
    || props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE
    || props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE;
  }

  const isValidCfOrPiva = (datiRichiesta) => {
    switch (props.choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
        return Validator.isValidPiva(datiRichiesta.partitaIvaRichiedente) //AZIENDA
          && Validator.isValidCf(datiRichiesta.codiceFiscaleRichiedente); // DELEGATO
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE:
            return Validator.isValidPiva(datiRichiesta.partitaIvaRichiedente) //AZIENDA
              && Validator.isValidCf(datiRichiesta.codiceFiscaleRichiedente); // DELEGATO    
      case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
        return Validator.isValidCfOrPiva(datiRichiesta.codiceFiscaleRichiedente) //INTERMEDIARIO
          && Validator.isValidPiva(datiRichiesta.partitaIvaRichiedente); // INTERMEDIARIO
      default:
        return Validator.isValidCf(datiRichiesta.codiceFiscaleRichiedente);
    }
  }

  const isValidRichiesta = (datiRichiesta) => {
    console.log('datiRichiesta', datiRichiesta)
    return isValidCfOrPiva(datiRichiesta)
      && Validator.isValidAppellativo(datiRichiesta.cognome)
      && (Validator.isValidAppellativo(datiRichiesta.nome) || isDitta())
      && (Validator.isValidData(datiRichiesta.dataNascita) || isDitta())
      && (Validator.isValidProvincia(datiRichiesta.provinciaNascita) || isDitta())
      && (Validator.isValidAppellativo(datiRichiesta.comuneNascita) || isDitta())
      && Validator.isValidTargaOrTelaio(datiRichiesta.targa)
      && Validator.isValidData(datiRichiesta.dataPagamento)
      && Validator.isValidNumber(datiRichiesta.scadenza) // ora è Number
      && Validator.isValidNumber(datiRichiesta.validita)
      && Validator.isValidNumber(datiRichiesta.tipoVeicolo)
      && Validator.isValidAppellativo(datiRichiesta.descComuneRes)
      && Validator.isValidProvincia(datiRichiesta.provinciaRes)
      && Validator.isValidIndirizzo(datiRichiesta.indirizzoRes)
      && Validator.isValidCivico(datiRichiesta.civicoRes)
      && Validator.isValidNumber(datiRichiesta.capRes)
      && Validator.isValidTelefono(datiRichiesta.telefono)
      && Validator.isValidEmail(datiRichiesta.email)
      && (Validator.isValidIban(datiRichiesta.iban) || props.allineamento)
      && (datiRichiesta.allegati.length === 1) //array con dentro 1 json map
      && Validator.isValidBoolean(datiRichiesta.isCorrezioneScadenza) // automatic input
      && (Validator.isValidCharacter(datiRichiesta.tipoProprietario))
      ;
  }

  const isValidForm = () => {
    if (isLoading) { return true; }
    console.log(fileUploads.size + "===" + props.numeroAllegati + (fileUploads.size === parseInt(props.numeroAllegati)));
    console.log(isTab_1_2_3_4_Completed());
    return isTab_1_2_3_4_Completed()
      && (fileUploads.size === parseInt(props.numeroAllegati));
  }

  const isTab_1_Completed = () => {
    switch (props.choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
        return (Validator.isValidPiva(partitaIva) //azienda
          && Validator.isValidCf(codiceFiscale) // delegato (colui che è loggato)
          && Validator.isValidAppellativo(cognome) // ragione sociale azienda
        );
      //STALIGK-793: aggiunto veicoli aziendali fuori regione 
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE:
          return (Validator.isValidPiva(partitaIva) //azienda
            && Validator.isValidCf(codiceFiscale) // delegato (colui che è loggato)
            && Validator.isValidAppellativo(cognome) // ragione sociale azienda
        );  
      case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
        return (Validator.isValidCfOrPiva(codiceFiscale) //intermediario (richiedente)
          && (partitaIva.length == 0  || partitaIva.length > 0 && Validator.isValidPiva(partitaIva)) //intermediario (richiedente)
          && Validator.isValidAppellativo(cognome) // ragione sociale
        );
      default:
        return (Validator.isValidCf(codiceFiscale) // anagrafica richiedente
          && Validator.isValidData(dataNascita)
          && Validator.isValidAppellativo(nome)
          && Validator.isValidAppellativo(cognome)
          && Validator.isValidAppellativo(comuneNascita)
          && Validator.isValidProvincia(provinciaNascita)
        );
    }
  }

  const isTab_1_2_Completed = () => {
    return isTab_1_Completed()
      && Validator.isValidTargaOrTelaio(targa)
      && Validator.isValidNumber(tipoVeicolo.value)
      && Validator.isValidData(dataPagamento)
      && Validator.isValidData(scadenza)
      && Validator.isValidNumber(validita)
  }

  const isTab_1_2_3_Completed = () => {
    return isTab_1_2_Completed()
      && Validator.isValidAppellativo(descComuneRes)
      && Validator.isValidProvincia(provinciaRes)
      && Validator.isValidIndirizzo(indirizzoRes)
      && Validator.isValidCivico(civicoRes)
      && Validator.isValidNumber(capRes)
  }

  const isTab_1_2_3_4_Completed = () => {
    return isTab_1_2_3_Completed()
      && Validator.isValidTelefono(telefono)
      && Validator.isValidEmail(email)
      && (Validator.isValidIban(iban) || props.allineamento)
  }

  const onCfChanged = (event) => { setCodiceFiscale(event.target.value.toUpperCase()) }
  const onPartitaIvaChanged = (event) => { setPartitaIva(event.target.value.toUpperCase()) }
  const onTargaChanged = (event) => { setTarga(event.target.value.toUpperCase()) }
  const onNomeChanged = (event) => { setNome(event.target.value.toUpperCase()) }
  const onCognomeChanged = (event) => { setCognome(event.target.value.toUpperCase()) }
  const onScadenzaChanged = (event) => { setScadenza(event.target.value); }
  const onValiditaChanged = (event) => { setValidita(event.target.value); }
  const onTipoVeicoloChanged = (event) => { setTipoVeicolo(event); }
  const onComuneNascitaChanged = (event) => { setComuneNascita(event.target.value.toUpperCase()); }
  const onProvinciaNascitaChanged = (event) => { if (event.target.value.length <= 2) { setProvinciaNascita(event.target.value.toUpperCase()); } }
  const onDataNascitaChanged = (event) => { setDataNascita(event.target.value); }
  const onDataPagamentoChanged = (event) => { setDataPagamento(event.target.value); }
  const onDescComuneResChanged = (event) => { setDescComuneRes(event.target.value.toUpperCase()); }
  const onProvinciaResChanged = (event) => { if (event.target.value.length <= 2) { setProvinciaRes(event.target.value.toUpperCase()); } }
  const onCapResChanged = (event) => { setCapRes(event.target.value); }
  const onIndirizzoResChanged = (event) => { setIndirizzoRes(event.target.value.toUpperCase()); }
  const onCivicoResChanged = (event) => { setCivicoRes(event.target.value); }
  const onTelefonoChanged = (event) => { setTelefono(event.target.value); }
  const onEmailChanged = (event) => { setEmail(event.target.value.toLowerCase()); }
  const onIbanChanged = (event) => { setIban(event.target.value.toUpperCase()); }

  const buildRequestBody = () => {
    let allegati = []
    let allegatoMap = {}
    fileUploads.forEach((value, key) => {
      allegatoMap[key] = value;
    })
    allegati.push(allegatoMap);
    const body = {
      "codiceFiscaleRichiedente": codiceFiscale,
      "partitaIvaRichiedente": partitaIva,
      "targa": targa,
      "nome": nome,
      "cognome": cognome,
      "tipoVeicolo": tipoVeicolo.value,
      "scadenza": formatScadenza(scadenza),
      "validita": validita,
      "isCorrezioneScadenza": props.allineamento,
      "tipoProprietario": getTipoProprietario(props.choiceRimborso),
      "isRichiedenteDelegato": isRichiedenteDelegato(props.choiceRimborso),
      "comuneNascita": comuneNascita,
      "provinciaNascita": provinciaNascita,
      "dataNascita": dataNascita,
      "dataPagamento": dataPagamento,
      "descComuneRes": descComuneRes,
      "provinciaRes": provinciaRes,
      "capRes": capRes,
      "indirizzoRes": indirizzoRes,
      "civicoRes": civicoRes,
      "telefono": telefono,
      "email": email,
      "iban": iban,
      "allegati": allegati
    }
    return body;
  }

  const handleInviaRichiesta = () => {
    const requestBody = buildRequestBody();
    console.log('POST verso richiestaRimborso=', requestBody);
    sendRichiestaRimborso(requestBody);
  }

  const sendRichiestaRimborso = async (datiRichiesta) => {
    if (isValidRichiesta(datiRichiesta)) {
      setLoading(true)
      const esitoRichiestaRimborso = await postRichiestaRimborso(datiRichiesta);
      console.log('esitoRichiestaRimborso=', esitoRichiestaRimborso)

      if (esitoRichiestaRimborso !== undefined) {
        setEsito(esitoRichiestaRimborso) // TUTTO OK!
      } else {
        console.log('sendRichiestaRimborso: Mancata risposta!')
        const richiestaNonInviata = {
          "title": "Mancata risposta",
          "detail": "Il server non ha inviato una risposta valida",
          "status": 500
        }
        setEsito(richiestaNonInviata);
      }

    } else {
      console.log('sendRichiestaRimborso: richiesta NON valida!')
      const richiestaNonInviata = {
        "title": "Richiesta non inviata",
        "detail": "Uno o più dati inseriti non sono corretti",
        "status": 400
      }
      setEsito(richiestaNonInviata);
    }

    setLoading(false)
  }

  const showInputPivaIntermediario = () => { return (<Input id="inserisciPartitaIva" label="Partiva IVA" placeholder="P.IVA" value={partitaIva} type="text" onChange={onPartitaIvaChanged} valid={Validator.isValidPiva(partitaIva)}  />) }
  const showInputPiva = () => { return (<Input id="inserisciPartitaIva" label="Partiva IVA" placeholder="P.IVA" value={partitaIva} type="text" onChange={onPartitaIvaChanged} required valid={Validator.isValidPiva(partitaIva)} invalid={!Validator.isValidPiva(partitaIva)} />) }
  const showInputCf = () => { return (<Input id="inserisciCodiceFiscale" label="Codice fiscale" placeholder="Codice fiscale" value={codiceFiscale} type="text" onChange={onCfChanged} required valid={Validator.isValidCfOrPiva(codiceFiscale)} invalid={!Validator.isValidCfOrPiva(codiceFiscale)} disabled={props.isCfDisabled} />) }
  const showInputTelaio = () => { return (<Input id="inserisciTelaio" label="Targa o Telaio" placeholder="AB123CDAB123CDAB123CD" value={targa} type="text" onChange={onTargaChanged} required valid={Validator.isValidTargaOrTelaio(targa)} invalid={!Validator.isValidTargaOrTelaio(targa)} disabled={isInputDatiVeicoloDisabled()} />) }
  const showInputTarga = () => { return (<Input id="inserisciTarga" label="Targa" placeholder="AB123CD" value={targa} type="text" onChange={onTargaChanged} required valid={Validator.isValidTargaOrTelaio(targa)} invalid={!Validator.isValidTargaOrTelaio(targa)} disabled={isInputDatiVeicoloDisabled()} />) }
  const showInputNome = () => { return (<Input id="inserisciNome" label="Nome" placeholder="Mario" value={nome} type="text" onChange={onNomeChanged} required invalid={!Validator.isValidAppellativo(nome)} valid={Validator.isValidAppellativo(nome)}  disabled={isDitta()} />) }
  const showInputCognome = () => { return (<Input id="inserisciCognome" label={"Cognome"} placeholder={"Rossi"} value={cognome} type="text" onChange={onCognomeChanged} required invalid={!Validator.isValidAppellativo(cognome)} valid={Validator.isValidAppellativo(cognome)} />) }
  const showInputRagioneSociale = () => { return (<Input id="inserisciRagioneSociale" label={"Ragione sociale"} placeholder={"nome ditta"} value={cognome} type="text" onChange={onCognomeChanged} required invalid={!Validator.isValidAppellativo(cognome)} valid={Validator.isValidAppellativo(cognome)} />) }
  const showInputDataNascita = () => { return (<Input id="inserisciDataNascita" label="Data di Nascita" placeholder="gg/mm/aaaa" value={dataNascita} type="date" onChange={onDataNascitaChanged} required invalid={!Validator.isValidData(dataNascita)} valid={Validator.isValidData(dataNascita)} disabled={isDitta()} />) }
  const showInputDataPagamento = () => { return (<Input id="inserisciDataPagamento" label="Data del pagamento" placeholder="gg/mm/aaaa" value={dataPagamento} type="date" onChange={onDataPagamentoChanged} required invalid={!Validator.isValidData(dataPagamento)} valid={Validator.isValidData(dataPagamento)} disabled={isInputDatiVeicoloDisabled()} />) }
  const showInputScadenza = () => { return (<Input id="inserisciScadenza" label="Valido fino al (scadenza)" placeholder="Scadenza in formato aaaa-mm" value={scadenza} type="month" onChange={onScadenzaChanged} invalid={!Validator.isValidData(scadenza)} valid={Validator.isValidData(scadenza)} disabled={isInputDatiVeicoloDisabled()} />) }
  const showInputValidita = () => { return (<Input id="inserisciValidita" label="Validita in mesi" placeholder="" value={validita} type="number" min={1} max={12} onChange={onValiditaChanged} disabled={isInputDatiVeicoloDisabled()} />) }
  const showTipiVeicolo = () => { return (<Select id="tipoVeicolo" label="Tipo Veicolo" placeholder="Tipo veicolo" value={tipoVeicolo.value ? tipoVeicolo : ""} options={tipiVeicoli} onChange={onTipoVeicoloChanged} isDisabled={isInputDatiVeicoloDisabled()} />) }
  const showAlertCorrezioneScadenza = () => { return (props.allineamento ? <Alert color="info" >Richiesta per correzione scadenza</Alert> : React.Fragment) }
  const showInputComuneNascita = () => { return (<Input id="inserisciComuneNascita" label="Nato a" placeholder="" value={comuneNascita} type="text" onChange={onComuneNascitaChanged} required invalid={!Validator.isValidAppellativo(comuneNascita)} valid={Validator.isValidAppellativo(comuneNascita)} disabled={isDitta()} />) }
  const showInputProvinciaNascita = () => { return (<Input id="inserisciProvinciaNascita" label="Sigla provincia" placeholder="" value={provinciaNascita} type="text" onChange={onProvinciaNascitaChanged} required invalid={!Validator.isValidProvincia(provinciaNascita)} valid={Validator.isValidProvincia(provinciaNascita)} disabled={isDitta()} />) }
  const showInputDescComuneRes = () => { return (<Input id="inserisciDescComuneRes" label="Comune" placeholder="" value={descComuneRes} type="text" onChange={onDescComuneResChanged} required invalid={!Validator.isValidAppellativo(descComuneRes)} valid={Validator.isValidAppellativo(descComuneRes)} />) }
  const showInputProvinciaRes = () => { return (<Input id="inserisciProvinciaRes" label="Sigla provincia" placeholder="" value={provinciaRes} type="text" onChange={onProvinciaResChanged} required invalid={!Validator.isValidProvincia(provinciaRes)} valid={Validator.isValidProvincia(provinciaRes)} />) }
  const showInputCapRes = () => { return (<Input id="inserisciCapRes" label="CAP" placeholder="" value={capRes} type="text" minLength="5" maxlength="5" pattern="{Validator.FORMATO_CAP}" onChange={onCapResChanged} required valid={Validator.isValidCAP(capRes)} invalid={!Validator.isValidCAP(capRes)} />) }
  const showInputIndirizzoRes = () => { return (<Input id="inserisciIndirizzoRes" label="Via" placeholder="" value={indirizzoRes} type="text" onChange={onIndirizzoResChanged} required invalid={!Validator.isValidIndirizzo(indirizzoRes)} valid={Validator.isValidIndirizzo(indirizzoRes)} />) }
  const showInputIndirizzoSocieta = () => { return (<Input id="inserisciIndirizzoRes" label="Via (Indirizzo società)" placeholder="" value={indirizzoRes} type="text" onChange={onIndirizzoResChanged} required invalid={!Validator.isValidIndirizzo(indirizzoRes)} valid={Validator.isValidIndirizzo(indirizzoRes)} />) }
  const showInputCivicoRes = () => { return (<Input id="inserisciCivicoRes" label="Civico" placeholder="" value={civicoRes} type="text" onChange={onCivicoResChanged} required invalid={!Validator.isValidCivico(civicoRes)} valid={Validator.isValidCivico(civicoRes)} />) }
  const showInputTelefono = () => { return (<Input id="inserisciTelefono" label="Telefono" placeholder="" value={telefono} type="text" onChange={onTelefonoChanged} required invalid={!Validator.isValidTelefono(telefono)} valid={Validator.isValidTelefono(telefono)}/>) }
  const showInputEmail = () => { return (<Input id="inserisciEmail" label="e-mail" placeholder="es.: mario@rossi.it" value={email} type="email" onChange={onEmailChanged} required invalid={!Validator.isValidEmail(email)} valid={Validator.isValidEmail(email)} />) }
  const showInputIban = () => { return (<Input id="inserisciIban" label="IBAN" placeholder="" value={iban} type="text" onChange={onIbanChanged} required valid={Validator.isValidIban(iban) && !props.allineamento} invalid={!Validator.isValidIban(iban) &&  !props.allineamento} />) }
  const showError = () => { return (esito && esito.status) ? <Alert color="danger" >{esito.detail}</Alert> : <div></div> }

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const isFileTypeAllowed = (fileName) => {
    const array = fileName.split(".");
    if (array.length >= 1) {
      const type = array[array.length - 1];
      return Constants.FILE_TYPE_WHITELIST.includes(type.toUpperCase());
    }
    return false;
  }

  const handleFileUpload = async (event) => {
    console.log('handleFileUpload')
    const file = event.target.files[0];
    console.log('handleFileUpload', file);
    console.log('handleFileUpload filename', file.name);
    console.log('handleFileUpload file size (in bytes)', file.size);
    if (file.size > Constants.MAX_SIZE_ALLEGATO_IN_BYTES) {
      const richiestaNonInviata = {
        "title": "Dimensione massima superata",
        "detail": "Non è possibile inserire un allegato con dimensioni superiori a " + Constants.NUM_MEGABYTES + " MB",
        "status": 400
      }
      setEsito(richiestaNonInviata);
      return;
    }
/*
    if (!isFileTypeAllowed(file.name)) {
      const richiestaNonInviata = {
        "title": "Estensione del file non ammessa",
        "detail": "Non è possibile inserire un allegato con estensione diversa da " + Constants.FILE_TYPE_WHITELIST + ".",
        "status": 400
      }
      setEsito(richiestaNonInviata);
      return;
    }
*/
    if(!isPDF(file)){
      const richiestaNonInviata = {
        "title": "Estensione del file non ammessa",
        "detail": "fd Non è possibile inserire un allegato con estensione diversa da " + Constants.FILE_TYPE_WHITELIST + ".",
        "status": 400
      }
      setEsito(richiestaNonInviata);
      return;
    }

    let base64String = await toBase64(file);
    console.log('handleFileUpload', base64String);
    let listaFiles = new Map(fileUploads);
    listaFiles.set(file.name, base64String);
    listaFiles.forEach((value, key) => { console.log("chiave = " + key + " -  valore " + value) });
    setFileUploads(listaFiles);

  }

  function isPDF(file) {
    let isPdf = file.type === 'application/pdf';
    if(isPdf){
      isPdf = checkEstensioneFile(file);
      if(isPdf){
        return checkPDFSignatureFile(file);
      }
    }
    return isPdf;
  }
  
  function checkEstensioneFile(file) {
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension === 'pdf';
  }

  function fileToArray(file) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = function (event) {
        const arrayBuffer = event.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);
        resolve(uint8Array);
      };
      reader.onerror = function (event) {
        reject(new Error("Error reading file."));
      };
      reader.readAsArrayBuffer(file);
    });
  }
  
  async function checkPDFSignatureFile(file) {
    const pdfSignature = [0x25, 0x50, 0x44, 0x46]; // PDF file signature
    try {
      const array = await fileToArray(file);
      for (let i = 0; i < pdfSignature.length; i++) {
        if (array[i] !== pdfSignature[i]) {
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const handleDeleteAllegato = (key) => {
    console.log('handleDeleteAllegato', key)
    let listaFiles = new Map(fileUploads);
    listaFiles.delete(key);
    setFileUploads(listaFiles);
  }

  const showListaAllegatiRimborsi = () => {
    if (fileUploads.size > 0) {
      let files = Array.from(fileUploads.keys());
      return (
        <table className="table table-striped table-sm">
          <thead className="thead-light">
            <tr>
              <th className="align-middle text-center">#</th>
              <th className="align-middle text-center">Nome Allegato</th>
              <th className="align-middle text-right">Rimuovi</th>
            </tr>
          </thead>
          <tbody>
            {files.map((keyFileName, i) => (
              <tr key={i}>
                <td className="align-middle text-center">{++i}</td>
                <td className="align-middle text-center">{keyFileName}</td>
                <td className="align-middle text-right">
                  <Button className="btn btn-default" icon={true} size="xs">
                    <Icon icon="it-delete" onClick={() => handleDeleteAllegato(keyFileName)} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    } else {
      return (<div></div>)
    }
  }

  const showInputAllegato = () => {
    console.log("MN procaa_SCELTA: " , props.choiceRimborso );
    console.log("MN procaa_NUM: " , props.numeroAllegati);
    console.log("MN procaa_ALLINEAMENTO: " , props.allineamento)
    console.log("MN procaa_PROPS: " , props)

    let didascaliaAllegati = "È necessario inserire almeno {props.numeroAllegati} allegati:  documento di identità, la ricevuta di pagamento";
    if(props.numeroAllegati === "2"){
      didascaliaAllegati = "Documenti obbligatori:  documento di identità, ricevuta di pagamento";
    } else if (props.numeroAllegati === "3"){
      if(props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_LEASING){
        didascaliaAllegati = "Documenti obbligatori:  documento di identità, ricevuta di pagamento, stralcio del contratto di locazione ove indicata la competenza del pagamento";
      }else if(props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI){
        didascaliaAllegati = "Documenti obbligatori:  documento di identità e copia di entrambe le ricevute di pagamento (copia del versamento effettuato correttamente e copia del versamento di cui si richiede il rimborso)";
      }else{
        didascaliaAllegati = "Documenti obbligatori:  documento di identità, ricevuta di pagamento, carta di circolazione";  
      }
    } else if (props.numeroAllegati === "5"){
      didascaliaAllegati = "Documenti obbligatori:  documento di identità," + 
                           " la ricevuta di pagamento, dichiarazione  sostitutiva certificato di decesso" +
                           " dichiarazione eredi di rinuncia al credito, dichiarazione sostitutiva atto di notorieta'";
    }
    return (
      <div>
        <Alert color="info" >{didascaliaAllegati}</Alert>
        {fileUploads.size <= props.numeroAllegati ?
          ( 
            <div>
              <br/>
              <Input id="inserisciAllegato" label="Inserisci Allegato" placeholder="Inserisci file" type="file" value={''} onChange={handleFileUpload} accept={Constants.ACCEPTED_ATTACHMENT_TYPES} />
            </div>
          ) : (
            <Alert color="warning" >È stato raggiunto il numero massimo di allegati consentiti</Alert>
          )
        }
        <br></br>
        {showListaAllegatiRimborsi()}
      </div>
    )
  }

  const showInputTargaOrTelaio = () => {
    console.log("SWITCH", props.choiceRimborso)
    switch (props.choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI:
        return showInputTelaio();
      default:
        return showInputTarga();
    }
  }

  const showWarningInputTargaOrTelaio = () => {
    switch (props.choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI:
        return <Alert color="warning" >ATTENZIONE: &egrave; necessario inserire lo stesso  dato (targa o telaio) fornito in fase di pagamento</Alert>
      default:
        return React.Fragment;
    }
  }

  const getDatiAnagrafici = () => {
    switch (props.choiceRimborso) {
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
        return (
          <Container className="px-2 my-2" id="rimborsi1" tag="section" >
            <Row><Col>{showAlertCorrezioneScadenza()}</Col></Row>
            <Row><Col>{showInputPiva()}</Col></Row>
            <Row><Col>{showInputRagioneSociale()}</Col></Row>
          </Container>
        );
      //STALIGK-793: aggiunto veicoli aziendali fuori regione 
      case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE:
        return (
          <Container className="px-2 my-2" id="rimborsi1" tag="section" >
            <Row><Col>{showAlertCorrezioneScadenza()}</Col></Row>
            <Row><Col>{showInputPiva()}</Col></Row>
            <Row><Col>{showInputRagioneSociale()}</Col></Row>
          </Container>
        );  
      case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
        return (
          <Container className="px-2 my-2" id="rimborsi1" tag="section" >
            <Row><Col>{showAlertCorrezioneScadenza()}</Col></Row>
            <Row><Col>{showInputCf()}</Col></Row>
            <Row><Col>{showInputPivaIntermediario()}</Col></Row>
            <Row><Col>{showInputRagioneSociale()}</Col></Row>
          </Container>
        );
      default:
        return (
          <Container className="px-2 my-2" id="rimborsi1" tag="section" >
            <Row><Col>{showAlertCorrezioneScadenza()}</Col></Row>
            <Row><Col>{showInputCf()}</Col></Row>
            <Row><Col>{showInputNome()}</Col><Col>{showInputCognome()}</Col></Row>
            <Row><Col>{showInputDataNascita()}</Col><Col></Col></Row>
            <Row><Col>{showInputComuneNascita()}</Col><Col>{showInputProvinciaNascita()}</Col></Row>
          </Container>
        );
    }
  }

  const getDatiPagamento = () => {
    return (
      <Container className="px-2 my-2" id="rimborsi2" tag="section" >
        <Row><Col>{showWarningInputTargaOrTelaio()}</Col></Row>
        <Row><Col>{showInputTargaOrTelaio()}</Col><Col>{showTipiVeicolo()}</Col></Row>
        <Row><Col>{showInputDataPagamento()}</Col><Col>{showInputValidita()}</Col></Row>
        <Row><Col>{showInputScadenza()}</Col><Col></Col></Row>
      </Container>
    );
  }

  const getDatiResidenza = () => {
    //STALIGK-793: aggiunto veicoli aziendali fuori regione 
    if(props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI 
       || props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE 
       || props.choiceRimborso === Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE){
      return (
        <Container className="px-2 my-2" id="rimborsi3" tag="section" >
          <Row><Col>{showInputIndirizzoSocieta()}</Col></Row>
          <Row><Col>{showInputCivicoRes()}</Col><Col>{showInputCapRes()}</Col></Row>
          <Row><Col>{showInputDescComuneRes()}</Col><Col>{showInputProvinciaRes()}</Col></Row>
        </Container>
      );
    } else {
      return (
        <Container className="px-2 my-2" id="rimborsi4" tag="section" >
          <Row><Col>{showInputIndirizzoRes()}</Col></Row>
          <Row><Col>{showInputCivicoRes()}</Col><Col>{showInputCapRes()}</Col></Row>
          <Row><Col>{showInputDescComuneRes()}</Col><Col>{showInputProvinciaRes()}</Col></Row>
        </Container>
      );
    }
  }

  const getDatiContatto = () => {
    if(props.allineamento){
      return (
        <Container className="px-2 my-2" id="rimborsi5" tag="section" >
          <Row><Col>{showInputTelefono()}</Col></Row>
          <Row><Col>{showInputEmail()}</Col></Row>
          <Row><Col>{showInputIban()}</Col></Row>
          <Alert color="warning" >Attenzione: l'IBAN deve essere intestato al richiedente. <br/> L'IBAN è obbligatorio solo se la quota ed interessi è superiore a 16 euro</Alert>
        </Container>
      );
    } else {
      return (
        <Container className="px-2 my-2" id="rimborsi6" tag="section" >
          <Row><Col>{showInputTelefono()}</Col></Row>
          <Row><Col>{showInputEmail()}</Col></Row>
          <Row><Col>{showInputIban()}</Col></Row>
          <Alert color="warning" >Attenzione: l'IBAN deve essere intestato al richiedente.</Alert>
        </Container>
      );
      }
  }

  const getDatiAllegati = () => {
    return (
      <Row><Col>{showInputAllegato()}</Col></Row>
    );
  }

  const getTabChoice = () => {
    console.log("passo da qua " + tabValue)
    switch (tabValue) {
      case Constants.STEP_1: return getDatiAnagrafici();
      case Constants.STEP_2: return getDatiPagamento();
      case Constants.STEP_3: return getDatiResidenza();
      case Constants.STEP_4: return getDatiContatto();
      case Constants.STEP_5: return getDatiAllegati();
      default:
        return getDatiAnagrafici();
    }
  }

  const handleClickDatiAnagrafici = () => { setTabValue(Constants.STEP_1); }
  const handleClickDatiPagamento = () => { setTabValue(Constants.STEP_2); }
  const handleClickDatiResidenza = () => { setTabValue(Constants.STEP_3); }
  const handleClickDatiContatto = () => { setTabValue(Constants.STEP_4); }
  const handleClickAllegati = () => { setTabValue(Constants.STEP_5); }

  const showBottoneInvia = () => {
    if (isTab_1_2_3_4_Completed() && tabValue === Constants.STEP_5) {
      return (
        <Button className="btn btn-primary"
          size="xs"
          color="primary"
          icon={false}
          tag="button"
          disabled={!isValidForm()}
          onClick={handleInviaRichiesta}>
          Invia richiesta
        </Button>
      )
    } else {
      return React.Fragment
    }
  }

  const configuraBottone = (label, handleClick, enabled) => {
    return (
      <Button className="btn btn-primary"
        size="xs"
        color="primary"
        icon={false}
        tag="button"
        disabled={!enabled}
        onClick={handleClick}>
        {label}
      </Button>
    )
  }

  const showBottoneNextTab = () => {
    switch (tabValue) {
      case Constants.STEP_1:
        if (isInputDatiVeicoloDisabled()) {
          // salto avanti allo STEP 3
          return configuraBottone(Constants.STR_BUTTON_AVANTI, handleClickDatiResidenza, isTab_1_2_Completed());
        } else {
          return configuraBottone(Constants.STR_BUTTON_AVANTI, handleClickDatiPagamento, isTab_1_Completed());
        }
      case Constants.STEP_2:
        return configuraBottone(Constants.STR_BUTTON_AVANTI, handleClickDatiResidenza, isTab_1_2_Completed());
      case Constants.STEP_3:
        return configuraBottone(Constants.STR_BUTTON_AVANTI, handleClickDatiContatto, isTab_1_2_3_Completed());
      case Constants.STEP_4:
        return configuraBottone(Constants.STR_BUTTON_AVANTI, handleClickAllegati, isTab_1_2_3_4_Completed());
      case Constants.STEP_5:
      default:
    }
  }

  const showBottonePreviousTab = () => {
    switch (tabValue) {
      case Constants.STEP_1:
        return configuraBottone(Constants.STR_BUTTON_INDIETRO, null, false);
      case Constants.STEP_2:
        return configuraBottone(Constants.STR_BUTTON_INDIETRO, handleClickDatiAnagrafici, true);
      case Constants.STEP_3:
        if (isInputDatiVeicoloDisabled()) {
          // salto indietro allo STEP 1
          return configuraBottone(Constants.STR_BUTTON_INDIETRO, handleClickDatiAnagrafici, true);
        } else {
          return configuraBottone(Constants.STR_BUTTON_INDIETRO, handleClickDatiPagamento, true);
        }
      case Constants.STEP_4:
        return configuraBottone(Constants.STR_BUTTON_INDIETRO, handleClickDatiResidenza, true);
      case Constants.STEP_5:
        return configuraBottone(Constants.STR_BUTTON_INDIETRO, handleClickDatiContatto, true);
      default:
    }
  }

  //START RENDERING
  if (isLoading === true) { return showProgress(); }

  if (esito && esito.messaggio) {
    return (
      <Container className="px-2 my-2" id="rimborsiForm" tag="section">
        <h3>{esito.messaggio}</h3>
        <br />
        <a href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}>
          Torna alla Home page
        </a>
      </Container>
    )
  } else {
    return (
      <Container className="px-2 my-2" id="rimborsiForm" tag="section" >
        {showError()}
        <Toolbar >
          <ToolbarItem label={Constants.STEP_1 + ". DATI ANAGRAFICI"} iconName="it-card" onClick={handleClickDatiAnagrafici} badge={tabValue === Constants.STEP_1} />
          <ToolbarItem label={Constants.STEP_2 + ". DATI DEL PAGAMENTO"} iconName="it-key" onClick={isTab_1_Completed() ? handleClickDatiPagamento : null} badge={tabValue === Constants.STEP_2} disabled={isInputDatiVeicoloDisabled() || !isTab_1_Completed()} />
          <ToolbarItem label={Constants.STEP_3 + ". ATTUALE RESIDENZA"} iconName="it-pa" onClick={isTab_1_2_Completed() ? handleClickDatiResidenza : null} badge={tabValue === Constants.STEP_3} disabled={!isTab_1_2_Completed()} />
          <ToolbarItem label={Constants.STEP_4 + ". DATI DI CONTATTO"} iconName="it-telephone" onClick={isTab_1_2_3_Completed() ? handleClickDatiContatto : null} badge={tabValue === Constants.STEP_4} disabled={!isTab_1_2_3_Completed()} />
          <ToolbarItem label={Constants.STEP_5 + ". ALLEGATI"} iconName="it-upload" onClick={isTab_1_2_3_4_Completed() ? handleClickAllegati : null} badge={tabValue === Constants.STEP_5} disabled={!isTab_1_2_3_4_Completed()} />
        </Toolbar>
        <FormGroup className="my-2" >
          {getTabChoice()}
        </FormGroup>
        <div className="btn-group mr-2">
          {showBottonePreviousTab()}
          &nbsp;
          {showBottoneNextTab()}
          {showBottoneInvia()}
        </div>
        <Container className="px-2 my-2" id="stepper-nav" tag="div">
          <Row>
            <Col>
              <div className="btn-toolbar justify-content-between" role="toolbar">
                <div className="btn-group mr-2">
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag='a'
                    href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                    role='button'
                  > {Constants.STR_BUTTON_RESET}
                  </Button>
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag="button"
                    onClick={props.handleBack}
                  > {isInputDatiVeicoloDisabled() ? Constants.STR_BUTTON_TORNA_A_ELENCO_PAGAMENTI : Constants.STR_BUTTON_TORNA_A_TIPO_RIMBORSO}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    )
  }
}

export default SibaInputFormRichiestaRimborso;